import * as api from '../../api/index';
import { FETCH_ALL_CUSTOMER, CUSTOMER_LOADING } from '../actions'

export const getCustomers = () => async (dispatch) => {
    try {
        dispatch({ type: CUSTOMER_LOADING })
        const { data } = await api.fetchCustomers()
        dispatch({ type: FETCH_ALL_CUSTOMER, payload: data.data })

    } catch (error) {
        dispatch({ type: FETCH_ALL_CUSTOMER, payload: {} })
        console.log(error)
    }

}